import { Flex } from "antd";
import { FC } from "react";
import { Point, TaskDMP } from "tm-shared/types";

import {
    CustomTaskFromTaskButton,
    SubtaskCard,
    TaskViewModal,
} from "@/features/TaskView/components";

interface DmpViewModalProps {
    task: TaskDMP;
    point: Point;
    onClose: () => void;
}

export const DmpViewModal: FC<DmpViewModalProps> = ({
    task,
    point,
    onClose,
}) => {
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    const dmp = task.context.dmp;
    const taskImages = Object.values(taskPayload).flatMap(
        ({ photos }) => photos ?? [],
    );

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                <CustomTaskFromTaskButton
                    task={task}
                    point={point}
                    images={taskImages}
                />
                {dmp.map(({ subtaskId, name }) => {
                    const subtaskPayload = taskPayload[subtaskId];

                    if (!subtaskPayload) return null;

                    return (
                        <SubtaskCard
                            key={subtaskId}
                            subtask={subtaskPayload}
                            title={name}
                        />
                    );
                })}
            </Flex>
        </TaskViewModal>
    );
};
